import { render } from "./MngCategory.vue?vue&type=template&id=c327a682&scoped=true&ts=true"
import script from "./MngCategory.vue?vue&type=script&lang=ts"
export * from "./MngCategory.vue?vue&type=script&lang=ts"

import "./MngCategory.vue?vue&type=style&index=0&id=c327a682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c327a682"]])

export default __exports__